// @ts-nocheck

import React, { memo } from 'react';
import styled from 'styled-components';

import { Star } from '../../assets/svg';
import { __ } from '../../i18n/l10n';
import {
  MenuDesktopArrowIcon,
  SportsMenuBtnContent,
  SportsMenuBtnLabel,
  SportsMenuListItem,
} from '../../styled-components/shared';
import RoutesRedirectionFactory from '../../utils/routes/RoutesRedirectionFactory';
import Counter from '../Counter';

const StyledCounter = styled(Counter)`
  width: 1.6em;
  height: 1.6em;
  font-weight: bold;
  font-size: 94%;
`;

const StarIcon = styled(Star)`
  width: 1.4em;
  height: 1.4em;
  margin: 0 0.7em;
  font-size: 0.9em;
`;

type MenuDesktopFavoriteButtonProps = {
  nbFavorites: number;
  clearFavoritePreferences: () => void;
};

const MenuDesktopFavoriteButton = ({ nbFavorites, clearFavoritePreferences }: MenuDesktopFavoriteButtonProps) => {
  return (
    <SportsMenuListItem
      to={RoutesRedirectionFactory.getFavoritesRouteConfig()}
      onClick={() => {
        clearFavoritePreferences();
      }}
    >
      <SportsMenuBtnContent>
        <StarIcon />
        <SportsMenuBtnLabel>
          {__('My favourites')}
          <StyledCounter counter={nbFavorites} />
        </SportsMenuBtnLabel>
      </SportsMenuBtnContent>
      <MenuDesktopArrowIcon className="see-all-btn" />
    </SportsMenuListItem>
  );
};

export default memo<MenuDesktopFavoriteButtonProps>(MenuDesktopFavoriteButton);
